<template>
  <DocumentFormSection id="operational-links" :required="false" :slot-max-width="608">
    <div v-if="operationalExperiences.length" class="flex flex-col gap-4">
      <RawOperationalLinkCard
        v-for="link in readonlyLinks"
        :key="link.key"
        :link="link.instance"
        :selected-operational-ids="selectedOperationalIds"
        :readonly="true"
        :dropdown-locked="true"
        @remove="() => {}"
      />
    </div>
    <p v-else class="text-sm text-text-80">{{ $t("common.no-content") }}</p>
  </DocumentFormSection>
</template>

<script setup lang="ts">
import RawOperationalLinkCard from "@/features/experience-raw/sections/operational-links/RawOperationalLinkCard.vue";
import {
  useRawOperationalLinkFactory,
  mapOperationalExperienceToLinkData,
} from "@/features/experience-raw/sections/operational-links/useRawOperationalLinkFactory";
import { RevisionFormProps } from "../types/forms";

const { $t } = useNuxtApp();

const props = defineProps<RevisionFormProps>();

const operationalExperiences = computed(() => props.values?.operationalExperiences ?? []);

const readonlyLinks = computed(() =>
  operationalExperiences.value.map((op) => ({
    key: op.operational_id,
    instance: useRawOperationalLinkFactory(mapOperationalExperienceToLinkData(op)),
  }))
);

const selectedOperationalIds = computed(() => {
  return new Set(operationalExperiences.value.map((op) => op.operational_id));
});
</script>
